<template>
  <div>
    <div
      id="google_translate_element"
      class="mr-3"
      @change="$emit('languageChanged')"
    ></div>
    <v-progress-linear
      :active="loading"
      :indeterminate="loading"
      absolute
      bottom
      color="primary"
      height="5"
      striped
    />
    <v-list class="hide">
      <v-list-item
        v-for="(option, index) in optionsArray"
        :key="index"
        @click="selectIndex(option.index)"
      >
        <v-list-item-title class="listItem">{{
          option.text
        }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
// languages: "ar,bn,de,en,es,fr,hi,it,ja,jw,ko,mr,pa,pt,ru,ta,te,tr,vi,zh-CN",

export default {
  data() {
    return {
      languages:
        "ar,bn,de,en,es,fr,hi,it,ja,jw,ko,mr,pa,pt,ru,ta,te,tr,vi,zh-CN",
      optionsArray: [],
      loading: false,
      selectedLanguage: {
        text: "English",
        value: "en",
        index: 3,
      },
    };
  },
  methods: {
    initializeGoogleTranslate() {
      const element = document.getElementById("google_translate_element");
      if (
        !element ||
        element.childElementCount > 0 ||
        !window.google?.translate?.TranslateElement
      ) {
        return;
      }

      new window.google.translate.TranslateElement(
        {
          includedLanguages: this.languages,
          autoDisplay: true,
        },
        "google_translate_element",
      );
    },
    googleTranslateWidget() {
      if (window.google?.translate?.TranslateElement) {
        this.initializeGoogleTranslate();
        return;
      }

      window.googleTranslateElementInit = () => {
        this.initializeGoogleTranslate();
      };

      if (document.getElementById("google-translate-element-script")) {
        return;
      }

      const translateScript = document.createElement("script");
      translateScript.id = "google-translate-element-script";
      translateScript.src =
        "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      document.head.appendChild(translateScript);
    },
    getSelectOptions() {
      const selectElement = document.querySelector(".goog-te-combo");
      if (selectElement) {
        const options = selectElement.options;
        console.log("selectElement.options", options);
        const optionsArray = [];

        // Iterate over the options
        for (let i = 0; i < options.length; i++) {
          const option = options[i];
          const optionObject = {
            text: option.text,
            value: option.value,
            index: i,
          };
          optionsArray.push(optionObject);
        }
        console.log(optionsArray);
        this.optionsArray = optionsArray;
      }
    },
    selectIndex(index) {
      this.selectedLanguage = this.optionsArray[index];
      const selectElement = document.querySelector(".goog-te-combo");
      if (selectElement) {
        selectElement.selectedIndex = index;
        const event = new Event("change", { bubbles: true });
        selectElement.dispatchEvent(event);
      }
    },
  },
  mounted() {
    this.googleTranslateWidget();
  },
};
</script>

<style>
#google_translate_element {
  margin-top: 15px;
}
.skiptranslate.goog-te-gadget {
  visibility: hidden;
}
#\:0\.targetLanguage {
  visibility: visible !important;
}
select.goog-te-combo {
  width: 100% !important;
  margin-top: 5px !important;
  padding: 5px !important;
  background-color: white;
  border: 3px solid #ccc !important;
  border-radius: 10px !important;
}
select.goog-te-combo > option {
  margin-top: 3px !important;
  font-size: 1.1rem !important;
  cursor: pointer !important;
}
.listItem {
  cursor: pointer;
  text-align: center !important;
  font-size: 1.1rem !important;
}
div.VIpgJd-ZVi9od-aZ2wEe-wOHMyf.VIpgJd-ZVi9od-aZ2wEe-wOHMyf-ti6hGc {
  display: none !important;
}
.hide {
  display: none !important;
}
</style>
